import { UserEffects } from './user.effects';
import { DoubtsEffects } from './doubts.effects';
import { CalendarEffects } from './calendar.effects';
import { PaymentsEffects } from './payments.effects';
import { ReviewsEffects } from './reviews.effects';
import { SubscriptionsEffects } from './subscriptions.effects';
import { ClientsControlEffects } from './clients-control.effects';
import { ResourcesEffects } from './resources.effects';

export const effects: any[] = [
  UserEffects,
  DoubtsEffects,
  CalendarEffects,
  PaymentsEffects,
  ReviewsEffects,
  SubscriptionsEffects,
  ClientsControlEffects,
  ResourcesEffects
];

export * from './user.effects';
export * from './doubts.effects';
export * from './calendar.effects';
export * from './payments.effects';
export * from './reviews.effects';
export * from './subscriptions.effects';
export * from './clients-control.effects';
export * from './resources.effects';
